import React, { useState, useEffect } from "react";
import { useBarOwnerData } from "../../../../context/BarOwnerDataContext";

const PendingInvites = () => {
  const [showCancelConfirm, setShowCancelConfirm] = useState(null);
  const { fetchPendingAdminInvites, getPendingAdminInvites } = useBarOwnerData();
  const { invites, loading, error } = getPendingAdminInvites();

  useEffect(() => {
    const cached = getPendingAdminInvites();
    if (!cached.hasFetched && !cached.loading) {
      fetchPendingAdminInvites();
    }
  }, [getPendingAdminInvites, fetchPendingAdminInvites]);

  const handleResendInvite = async (invite) => {
    try {
      // TODO: Implement resend functionality
      // For now, we'll just show a message
      alert("Resend functionality coming soon!");
    } catch (err) {
      console.error("Error resending invite:", err);
      alert("Failed to resend invite");
    }
  };

  const handleCancelInvite = async (inviteId) => {
    try {
      const response = await fetch(`/api/invites/${inviteId}`, {
        method: "DELETE",
        credentials: "include",
      });

      const data = await response.json();

      if (data.success) {
        setShowCancelConfirm(null);
        window.dispatchEvent(new CustomEvent("adminInvitesUpdated"));
      } else {
        alert(data.error || "Failed to cancel invite");
      }
    } catch (err) {
      console.error("Error cancelling invite:", err);
      alert("Failed to cancel invite");
    }
  };

  const getDaysUntilExpiry = (expiresAt) => {
    const now = new Date();
    const expiry = new Date(expiresAt);
    const diff = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
    return diff;
  };

  if (loading) {
    return (
      <div className="pending-invites-section">
        <div className="loading-message">Loading invites...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pending-invites-section">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="pending-invites-section">
      <div className="pending-invites-header">
        <h3>Pending Invites</h3>
        <span className="invite-count">{invites.length}</span>
      </div>

      {invites.length === 0 ? (
        <div className="no-invites-message">
          <p>No pending invites</p>
        </div>
      ) : (
        <div className="invites-list">
          {invites.map((invite) => {
            const daysLeft = getDaysUntilExpiry(invite.expires_at);
            const isExpiringSoon = daysLeft <= 2;

            return (
              <div
                key={invite.invite_id}
                className={`invite-item ${
                  isExpiringSoon ? "expiring-soon" : ""
                }`}
              >
                <div className="invite-info">
                  <div className="invite-main">
                    <span className="invite-icon">📧</span>
                    <div className="invite-details">
                      <h4 className="invite-email">
                        {invite.recipient_name ||
                          invite.recipient_email ||
                          invite.recipient_user_email}
                      </h4>
                      <p className="invite-bar">{invite.bar_name}</p>
                    </div>
                  </div>

                  <div className="invite-meta">
                    <p className="invite-date">
                      Sent: {new Date(invite.created_at).toLocaleDateString()}
                    </p>
                    <p
                      className={`invite-expiry ${
                        isExpiringSoon ? "expiring" : ""
                      }`}
                    >
                      {daysLeft > 0
                        ? `Expires in ${daysLeft} ${
                            daysLeft === 1 ? "day" : "days"
                          }`
                        : "Expired"}
                    </p>
                  </div>
                </div>

                <div className="invite-actions">
                  <button
                    className="action-btn"
                    onClick={() => handleResendInvite(invite)}
                  >
                    Resend
                  </button>
                  <button
                    className="cancel-btn"
                    onClick={() => setShowCancelConfirm(invite)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Cancel Confirmation Modal */}
      {showCancelConfirm && (
        <div
          className="modal-overlay"
          onClick={() => setShowCancelConfirm(null)}
        >
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Cancel Invite</h3>
              <button
                className="modal-close-btn"
                onClick={() => setShowCancelConfirm(null)}
              >
                ×
              </button>
            </div>
            <div className="modal-content">
              <p>
                Are you sure you want to cancel the invite to{" "}
                <strong>
                  {showCancelConfirm.recipient_email ||
                    showCancelConfirm.recipient_user_email}
                </strong>
                ?
              </p>
              <p>They will no longer be able to accept this invitation.</p>
              <div className="modal-actions">
                <button
                  className="cancel-btn"
                  onClick={() => setShowCancelConfirm(null)}
                >
                  Keep Invite
                </button>
                <button
                  className="danger-btn"
                  onClick={() =>
                    handleCancelInvite(showCancelConfirm.invite_id)
                  }
                >
                  Yes, Cancel Invite
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PendingInvites;
